"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var helper_1 = require("../../utils/helper");
var theme_1 = require("../../utils/theme");
var TOOLTIP_GAP = 11;
var Tooltip = (function (_super) {
    tslib_1.__extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootRef = React.createRef();
        _this.overlayContainerRef = React.createRef();
        _this.state = {
            currentVisible: !!_this.props.defaultVisible
        };
        _this.show = function () {
            if (_this.props.disabled) {
                return;
            }
            _this.setState({ currentVisible: true }, function () {
                _this.props.onVisibleChange(true);
            });
        };
        _this.hide = function () {
            if (!_this.isVisible()) {
                return;
            }
            _this.setState({ currentVisible: false }, function () {
                _this.props.onVisibleChange(false);
            });
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, className = _b.className, style = _b.style, prefixCls = _b.prefixCls, title = _b.title, placement = _b.placement, children = _b.children, arrowClassName = _b.arrowClassName, overlayClassName = _b.overlayClassName, overlayStyle = _b.overlayStyle, arrowStyle = _b.arrowStyle, offset = _b.offset, zIndex = _b.zIndex;
            var wrapperCls = classNames(prefixCls, className, prefixCls + "-wrapper");
            var overlayCls = classNames(prefixCls + "-content", overlayClassName);
            var overlayStyleWithOffset = tslib_1.__assign(tslib_1.__assign({}, overlayStyle), { transform: "translate" + (placement === 'top' || placement === 'bottom' ? 'X' : 'Y') + "(" + offset + "px)" });
            var arrowCls = classNames(prefixCls + "-arrow", arrowClassName, prefixCls + "-arrow-" + placement);
            var overlayContainerCls = classNames(prefixCls + "-container", (_a = {},
                _a[prefixCls + "-container-visible"] = _this.isVisible(),
                _a));
            var overlayContainerStyle = _this.calcOverlayContainerPosition();
            return (h("div", { className: wrapperCls, style: style, onTouchStart: _this.show, ref: _this.rootRef },
                children,
                react_dom_1.default.createPortal(h("div", { className: overlayContainerCls, ref: _this.overlayContainerRef, style: tslib_1.__assign({ zIndex: zIndex }, overlayContainerStyle) },
                    h("div", { className: overlayCls, style: overlayStyleWithOffset }, title),
                    h("div", { className: arrowCls, style: arrowStyle })), document.body)));
        };
        return _this;
    }
    Tooltip.getDerivedStateFromProps = function (props, state) {
        if (props.disabled) {
            return { currentVisible: false };
        }
        return null;
    };
    Tooltip.prototype.isVisible = function () {
        var _a = this.props, forceVisible = _a.visible, disabled = _a.disabled;
        if (disabled) {
            return false;
        }
        var stateVisible = this.state.currentVisible;
        return typeof forceVisible === 'boolean' ? forceVisible : stateVisible;
    };
    Tooltip.prototype.calcOverlayContainerPosition = function () {
        var rootDom = this.rootRef.current;
        var containerDom = this.overlayContainerRef.current;
        if (!rootDom || !containerDom) {
            return { left: '0px', top: '0px' };
        }
        var _a = rootDom.getBoundingClientRect(), leftX = _a.left, rightX = _a.right, topY = _a.top, bottomY = _a.bottom;
        var _b = containerDom.getBoundingClientRect(), width = _b.width, height = _b.height;
        var _c = this.props, placement = _c.placement, containerOffsetX = _c.containerOffsetX, containerOffsetY = _c.containerOffsetY;
        var centerX = (leftX + rightX) / 2;
        var centerY = (topY + bottomY) / 2;
        var resultLeft = window.pageXOffset + containerOffsetX;
        var resultTop = window.pageYOffset + containerOffsetY;
        if (placement === 'bottom') {
            resultLeft += centerX - width / 2;
            resultTop += bottomY + TOOLTIP_GAP;
        }
        else if (placement === 'top') {
            resultLeft += centerX - width / 2;
            resultTop += topY - TOOLTIP_GAP - height;
        }
        else if (placement === 'left') {
            resultLeft += leftX - TOOLTIP_GAP - width;
            resultTop += centerY - height / 2;
        }
        else if (placement === 'right') {
            resultLeft += rightX + TOOLTIP_GAP;
            resultTop += centerY - height / 2;
        }
        return { left: resultLeft + "px", top: resultTop + "px" };
    };
    Tooltip.prototype.componentDidMount = function () {
        this.forceUpdate();
        document.addEventListener('touchmove', this.hide);
        document.addEventListener('touchend', this.hide);
        document.addEventListener('touchcancel', this.hide);
    };
    Tooltip.prototype.componentWillUnmount = function () {
        document.removeEventListener('touchmove', this.hide);
        document.removeEventListener('touchend', this.hide);
        document.removeEventListener('touchcancel', this.hide);
    };
    Tooltip.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Tooltip;
}(React.Component));
exports.default = Tooltip;
Tooltip.defaultProps = {
    prefixCls: 'dui-m-tooltip',
    title: '',
    placement: 'bottom',
    onVisibleChange: helper_1.emptyFn,
    disabled: false,
    offset: 0,
    containerOffsetX: 0,
    containerOffsetY: 0
};
Tooltip.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    placement: PropTypes.string,
    title: PropTypes.node,
    defaultVisible: PropTypes.bool,
    visible: PropTypes.bool,
    onVisibleChange: PropTypes.func,
    overlayStyle: PropTypes.object,
    overlayClassName: PropTypes.string,
    disabled: PropTypes.bool,
    arrowStyle: PropTypes.object,
    arrowClassName: PropTypes.string,
    offset: PropTypes.number,
    containerOffsetX: PropTypes.number,
    containerOffsetY: PropTypes.number,
    zIndex: PropTypes.number
};
